import React, { useState, useEffect } from "react";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { loansAPI } from "../../services/api";
import "./Admin.css";

const STATUS_LABELS = {
  pending: "Pendiente",
  approved: "Aprobado",
  rejected: "Rechazado",
  completed: "Completado",
  cancelled: "Cancelado",
};

const STATUS_COLORS = {
  pending: "#f39c12",
  approved: "#2ecc71",
  rejected: "#e74c3c",
  completed: "#3498db",
  cancelled: "#95a5a6",
};

const Loans = () => {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchLoans();
  }, [statusFilter, page]);

  const fetchLoans = async () => {
    try {
      setLoading(true);
      const res = await loansAPI.getLoans({ status: statusFilter, page, limit: 20 });
      setLoans(res.data.loans);
      setTotalPages(res.data.totalPages);
    } catch (error) {
      console.error("Error fetching loans:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (loanId, newStatus) => {
    try {
      await loansAPI.updateLoan(loanId, { status: newStatus });
      fetchLoans();
    } catch (error) {
      console.error("Error updating loan:", error);
    }
  };

  const handleDelete = async (loanId) => {
    if (window.confirm("¿Está seguro de eliminar este préstamo?")) {
      try {
        await loansAPI.deleteLoan(loanId);
        fetchLoans();
      } catch (error) {
        console.error("Error deleting loan:", error);
      }
    }
  };

  return (
    <DashboardLayout title="Gestión de Préstamos">
      {/* Filters */}
      <div className="filters-bar">
        <select value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }}>
          <option value="">Todos los estados</option>
          {Object.entries(STATUS_LABELS).map(([key, label]) => (
            <option key={key} value={key}>{label}</option>
          ))}
        </select>
        <span className="results-count">{loans.length} resultados</span>
      </div>

      {/* Table */}
      {loading ? (
        <div className="loading">Cargando...</div>
      ) : (
        <>
          <div className="data-table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Email</th>
                  <th>Teléfono</th>
                  <th>Monto</th>
                  <th>Tipo</th>
                  <th>Estado</th>
                  <th>Fecha</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {loans.length === 0 ? (
                  <tr><td colSpan="8" className="empty-row">No hay préstamos registrados</td></tr>
                ) : (
                  loans.map((loan) => (
                    <tr key={loan._id}>
                      <td>{loan.firstName} {loan.lastName}</td>
                      <td>{loan.email}</td>
                      <td>{loan.phone}</td>
                      <td>${loan.loanAmount?.toLocaleString()}</td>
                      <td>{loan.loanType}</td>
                      <td>
                        <span
                          className="status-badge"
                          style={{ backgroundColor: STATUS_COLORS[loan.status] }}
                        >
                          {STATUS_LABELS[loan.status]}
                        </span>
                      </td>
                      <td>{new Date(loan.createdAt).toLocaleDateString()}</td>
                      <td className="actions-cell">
                        <select
                          value={loan.status}
                          onChange={(e) => handleStatusChange(loan._id, e.target.value)}
                          className="action-select"
                        >
                          {Object.entries(STATUS_LABELS).map(([key, label]) => (
                            <option key={key} value={key}>{label}</option>
                          ))}
                        </select>
                        <button onClick={() => handleDelete(loan._id)} className="btn-danger-sm">
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pagination">
              <button disabled={page <= 1} onClick={() => setPage(page - 1)}>Anterior</button>
              <span>Página {page} de {totalPages}</span>
              <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Siguiente</button>
            </div>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default Loans;
